<template>
  <v-form
    ref="formInsc"
    v-model="valid"
  >
    <v-container>
      <v-row class="">
        <v-col cols="12" class="text-center pb-0">
          <h3>Inscreva-se já!</h3>
          <p class="mt-2 mb-0 body-2">Preencha o formulário abaixo e faça a sua inscrição:</p>
        </v-col>
        <v-col cols="12" class="pa-1">
          <!-- <v-stepper v-model="e1" alt-labels class="transparent elevation-0"> -->

            <!-- <v-stepper-items> -->
              <!-- <v-stepper-content step="1" flat class="px-0 py-0"> -->
                <v-container>
                  <v-row class="pa-0">
                    <!-- email -->
                    <v-col cols="12" class="pa-1 my-2">
                      <v-text-field
                        v-model="email"
                        label="Email*"
                        hint="ex.: email@exemplo.com"
                        filled
                        validate-on-blur
                        hide-details="auto"
                        :rules="[requiredRule, emailRule]"
                        class=""
                      ></v-text-field>
                      <v-alert
                        dense
                        color="info"
                        dark
                        class="caption mt-2 mb-0"
                      >
                        <v-icon left small color="white">mdi-information</v-icon>
                        Email que será usado para acessar o curso
                      </v-alert>
                    </v-col>
                    <!-- nome -->
                    <v-col cols="12" md="12" class="pa-1 my-2">
                      <v-text-field
                        v-model="nome"
                        label="Nome*"
                        hint="Digite seu nome."
                        filled
                        validate-on-blur
                        hide-details="auto"
                        :rules="[requiredRule]"
                        class=""
                      ></v-text-field>
                    </v-col>
                    <!-- sobrenome -->
                    <v-col cols="12" md="12" class="pa-1 my-2">
                      <v-text-field
                        v-model="sobrenome"
                        label="Sobrenome*"
                        hint="Sigite seu sobrenome."
                        filled
                        validate-on-blur
                        hide-details="auto"
                        :rules="[requiredRule]"
                        class=""
                      ></v-text-field>
                    </v-col>
                    <!-- especialidade -->
                    <v-col cols="12" class="pa-1 my-2">
                      <v-text-field
                        v-model="especialidade"
                        label="Especialidade*"
                        hint="Digite sua especialidade."
                        filled
                        validate-on-blur
                        color="c-primary"
                        hide-details="auto"
                        :rules="[requiredRule]"
                        class=""
                      ></v-text-field>
                    </v-col>
                    <!-- nascimento -->
                    <v-col cols="8" md="12" class="pa-1 my-2">
                      <v-text-field
                        v-model="nascimento"
                        v-mask="['##/##/####']"
                        label="Data de nascimento*"
                        hint="ex: 07/01/1992"
                        filled
                        validate-on-blur
                        hide-details="auto"
                        :rules="[requiredRule]"
                        class=""
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>

                <v-btn
                  color="btn-primary"
                  x-large
                  block
                  dark
                  depressed
                  class="font-weight-bold"
                  @click="validateStep()"
                >
                  Me inscrever agora
                </v-btn>
              <!-- </v-stepper-content> -->
            <!-- </v-stepper-items> -->
          <!-- </v-stepper> -->
        </v-col>
        <v-col cols="12" class="pa-1 mt-3 text-center caption">
          <p>
            Já possui uma conta?
            <a
              class="font-weight-bold"
              @click.stop="$router.push('/login')"
            >
              Faça login!
            </a>
          </p>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
// import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import {mask} from 'vue-the-mask'
import db from '@/firebase/init'
import axios from 'axios'

export default {
  directives: {mask},
  props: {
    cursoID: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      valid: true,
      nome: '',
      sobrenome: '',
      email: '',
      crm: '',
      especialidade: '',
      sexo: null,
      nascimento: '',
      e1: 1,
      // instituicao: '',
      requiredRule: v => !!v || 'Este campo é obrigatório',
      emailRule: v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      // feedback: []
    }
  },
  mounted() {
    // window.console.log(moment.now())
    // window.console.log(Date.now())
  },
  methods: {
    // showSnackbar (payload) {
    //   this.$notifier.showMessage({
    //     content: payload.content, 
    //     color: payload.color
    //   })
    // },
    setFeedback(payload){
      this.$store.commit('setFeedback', {
        show: payload.show,
        message: payload.message,
        btnTxt: payload.btnTxt,
        color: payload.color,
        textColor: payload.textColor
      })
    },

    validateStep() {
      const email = this.email.replace(/(<([^>]+)>)/gi, "").toLowerCase().trim();
      if(!!this.email && !!this.nome && !!this.sobrenome && !!this.nascimento && !!this.especialidade) {
        // const db = firebase.firestore()
        const nasc = moment(this.nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const diff = moment().diff(nasc, 'years', true)
        // console.log(nasc)
        // console.log(diff)
        // console.log(db)

        // this.$store.commit('setFeedback', {
        //   show: true,
        //   message: 'funcionoooooou',
        //   btnTxt: 'ok',
        //   color: 'red',
        //   textColor: 'white'
        // })
        // console.log(this.cursoID)

        db.collection(this.cursoID).doc(email)
          .get()
          .then((doc) => {
            if(doc.exists) {
              console.log('já existe')
              this.setFeedback({
                show: true,
                message: 'Este email já foi cadastrado em nossa plataforma',
                btnTxt: 'ok',
                color: 'amber',
                textColor: 'black--text'
              })
            } else if(diff < 18) {
              this.setFeedback({
                show: true,
                message: 'Você deve ser maior de 18 anos',
                btnTxt: 'ok',
                color: 'amber',
                textColor: 'black--text'
              })
            } else if(isNaN(diff)) {
              this.setFeedback({
                show: true,
                message: 'Insira uma data de nascimento válida',
                btnTxt: 'ok',
                color: 'amber',
                textColor: 'black--text'
              })
            } else {
              console.log('pode passar')
              this.validate()
            }
          })
          .catch((e) => console.log(e))
      } else {
        this.$store.commit('setFeedback', {
          show: true,
          message: 'Preencha todos os campos!',
          btnTxt: 'ok',
          color: 'amber',
          textColor: 'black--text'
        })
      }
    },
    validate() {
      // window.console.log(this.$refs.formInsc.validate())
      if(this.$refs.formInsc.validate()) {

        // this.feedback = []
        const name = this.nome.replace(/(<([^>]+)>)/gi, "").toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()).trim();
        const lastname = this.sobrenome.replace(/(<([^>]+)>)/gi, "").toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()).trim();
        const email = this.email.replace(/(<([^>]+)>)/gi, "").toLowerCase().trim();
        // const crm = this.crm.replace(/(<([^>]+)>)/gi, "").trim();
        const especialidade = this.especialidade.replace(/(<([^>]+)>)/gi, "").toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()).trim();
        const dtNasc = this.nascimento.replace(/(<([^>]+)>)/gi, "").toLowerCase().trim();
        const fullName = `${name} ${lastname}`;
        // const instituicao = this.instituicao.replace(/(<([^>]+)>)/gi, "").toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
        // const sexo = this.sexo;
        const tsCadastro = Date.now();
        const dtCadastro = moment().format('YYYY-MM-DD');

        // window.console.log(`name: ${name || 'vazio'}`)
        // this.feedback.push(name, lastname, email, crm, especialidade, instituicao)
        // window.console.log('passou!')
        // window.console.log({name, lastname, email, crm, especialidade, instituicao})

        const payload = {
          name, 
          lastname, 
          fullName, 
          email, 
          // crm, 
          especialidade, 
          tsCadastro, 
          dtCadastro, 
          dtNasc, 
          // sexo
          cursoID: this.cursoID
        }
        const lead1 = {
          Name: fullName,
          Email: email
        }
        this.addLeadLovers(lead1)
        this.$store.dispatch('addPreInsc', payload)
          .then(response => {
            window.console.log('response: ', response)

            if(response) {
              this.$router.push('/finalizar-inscricao')
              this.$refs.formInsc.reset()
            }
            else {
              // this.showSnackbar({
              //   content: 'Ops, parece que ocorreu um erro. Tente novamente mais tarde',
              //   color: 'red'
              // })
              this.setFeedback({
                show: true,
                message: 'Ops, parece que ocorreu um erro. Tente novamente mais tarde',
                btnTxt: 'ok',
                color: 'red',
                textColor: 'white--text'
              })
            }
          })
          .catch((e) => {
            console.log('addPreinsc erro: ', e.message)
          })
      
      }
      // else {
      //   this.showSnackbar({
      //     content: 'Este campo só aceita números, . ou -',
      //     color: 'amber darken-2'
      //   })
      // }
      
    },

    checkCRM(evt){
      evt = (evt) || window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
        // avisa que não pode
        // window.console.log('só pode numeros, . ou -')
        this.showSnackbar({
          content: 'Este campo só aceita números, . ou -',
          color: 'amber darken-2'
        })
        evt.preventDefault();
      } else {
        // console.log('é numero')
        // console.log(charCode)
        return true
      }
    },

    async addLeadLovers(lead){
      lead.MachineCode = 712453
      lead.EmailSequenceCode = 1669633
      lead.SequenceLevelCode = 1
      lead.Source = `Página de inscrição Cursos CMF`
      lead.Score = 40
      // await console.log(lead)
      const leadJSON = JSON.stringify(lead)
      console.log(leadJSON)

      const url = 'https://llapi.leadlovers.com/webapi/lead?token=24CEB6B82C0E4D4EA36B6582A5B48E4A'
      const config = {
          headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1bmlxdWVfbmFtZSI6IldlYkFwaSIsInN1YiI6IldlYkFwaSIsInJvbGUiOlsicmVhZCIsIndyaXRlIl0sImlzcyI6Imh0dHA6Ly93ZWJhcGlsbC5henVyZXdlYnNpdGVzLm5ldCIsImF1ZCI6IjFhOTE4YzA3NmE1YjQwN2Q5MmJkMjQ0YTUyYjZmYjc0IiwiZXhwIjoxNjA1NDQxMzM4LCJuYmYiOjE0NzU4NDEzMzh9.YIIpOycEAVr_xrJPLlEgZ4628pLt8hvWTCtjqPTaWMs',
          }
      };

      const result = await axios.post(url, leadJSON, config).then((result) => {
        return result.data
      }).catch((e) => {
        console.error( 'getStats erro: ', e.message)
      })

      console.log(result)
    }
  },
}
</script>

<style lang="scss">
.submit-btn {
  font-weight: bold;
}
</style>